import { styled, Box } from '@mui/material';

import { BANNER_HEIGHT_SPACING } from './DemoModeBanner/DemoModeBanner.styled';

export const AppLayoutRow = styled(Box)`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  position: relative;
`;

export const AppLayoutBase = styled(Box)`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
`;

export const DemoLayoutWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hideBanner',
})<{ hideBanner?: boolean }>`
  display: flex;
  flex-direction: column;

  ${({ hideBanner, theme }) =>
    !hideBanner &&
    `
  & .MuiDrawer-root .MuiPaper-root {
    padding-top: ${theme.spacing(BANNER_HEIGHT_SPACING)};
  }
  `}
`;

export const DemoOutline = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid ${({ theme }) => theme.palette.primary.main};
  pointer-events: none;
  z-index: ${({ theme }) => theme.zIndex.tooltip + 1};
`;
